export function getUnselectableRowIds(data, getIsRowLoading, getIsRowReadOnly, getRowId) {
    return data.filter((d) => (getIsRowLoading && getIsRowLoading(d)) || (getIsRowReadOnly && getIsRowReadOnly(d))).map((d) => getRowId(d));
}
